import React from 'react'
import IMG from './mysql.png'
function Mysql() {
  return (
<img src={IMG} style={{width:"200px",height:"150px"}} alt='mysql' />
  )
}

export default Mysql